import Store from './Renewal.Store';
import Behaviour from './Renewal.Behaviour';
import View from './Renewal.View';

const Renewal = Store(Behaviour(View));

export { Renewal };
